import React, { useContext } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HistoryIcon from "@mui/icons-material/History";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../App";

const LAST_JOB_LIST_URL_KEY = "lastJobListUrl";

const MobileBottomBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, handleShowLogin } = useContext(AuthContext);

  const getCurrentValue = () => {
    const path = location.pathname;
    if (path === "/" || path === "/jobs" || path.startsWith("/jobs?")) return "home";
    if (path === "/favorites") return "favorites";
    if (path === "/recent") return "recent";
    return "profile";
  };

  const handleChange = (event, newValue) => {
    if (newValue === "profile") {
      if (!isLoggedIn) {
        handleShowLogin();
        return;
      }
      navigate("/profile");
      return;
    }

    switch (newValue) {
      case "home":
        navigate(localStorage.getItem(LAST_JOB_LIST_URL_KEY) || "/jobs");
        break;
      case "favorites":
        navigate("/favorites");
        break;
      case "recent":
        navigate("/recent");
        break;
      default:
        navigate("/jobs");
    }
  };

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: "block", md: "none" },
        zIndex: 1000,
      }}
      elevation={8}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={handleChange}
      >
        <BottomNavigationAction
          label="Главная"
          value="home"
          icon={<HomeIcon />}
        />

        <BottomNavigationAction
          label="Избранное"
          value="favorites"
          icon={<FavoriteIcon />}
        />

        <BottomNavigationAction
          label="История"
          value="recent"
          icon={<HistoryIcon />}
        />

        <BottomNavigationAction
          label="Профиль"
          value="profile"
          icon={<PersonIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomBar;
